var map = {
	"./Multicall.json": 33373,
	"./erc20.json": 93324,
	"./erc721.json": 53400,
	"./farm.json": 38743,
	"./governancetoken.json": 53916,
	"./launchpad.json": 17841,
	"./lp.json": 39053,
	"./stakepool.json": 1672,
	"./weth.json": 69253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78350;